// extracted by mini-css-extract-plugin
export default {"configureSettings":"configureSettings-i8Ut7","formContainer":"formContainer-UtNkr","configForm":"configForm-hhhYT","footer":"footer-CUdWm","button":"button-yjyDe"};